import React, { useEffect } from "react";
import { getYear, getMonth } from "date-fns";
import Iconography, { IconographySizes } from "@hid-galaxy-ui/galaxy-react/components/Iconography";
import Button from "@hid-galaxy-ui/galaxy-react/components/Button";
import Dropdown from "@hid-galaxy-ui/galaxy-react/components/DropDown/Select";
export const CustomHeader = (props: {
  date: any;
  changeYear: any;
  changeMonth: any;
  decreaseMonth: any;
  increaseMonth: any;
  prevMonthButtonDisabled: any;
  nextMonthButtonDisabled: any;
  minDate?: Date;
  maxDate?: Date;
}) => {
  const {
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    minDate,
    maxDate,
  } = props;

  const currentYear = new Date().getFullYear();

  // Fallbacks if minDate or maxDate are not provided
  const minYear = minDate ? minDate.getFullYear() : currentYear - 10;
  const maxYear = maxDate ? maxDate.getFullYear() : currentYear + 10;

  const years = Array.from(
    { length: maxYear - minYear + 1 },
    (_, i) => minYear + i
  );

  const selectedYear = date.getFullYear();

  const allMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const startMonth = selectedYear === minYear ? minDate?.getMonth() || 0 : 0;
  const endMonth = selectedYear === maxYear ? maxDate?.getMonth() || 11 : 11;

  const months = allMonths.slice(startMonth, endMonth + 1);

  // Get the current month and find its position in the filtered months array
  const currentMonth = getMonth(date);
  const currentMonthName = allMonths[currentMonth];
  const currentMonthIndex = months.indexOf(currentMonthName);

  let selectedMonth: string;
  if (currentMonthIndex >= 0) {
    selectedMonth = months[currentMonthIndex];
  } else if (maxDate && months.includes(allMonths[maxDate.getMonth()])) {
    // Fallback to maxDate's month if available in allowed months
    selectedMonth = allMonths[maxDate.getMonth()];
  } else {
    // Fallback to the last available month in the allowed range
    selectedMonth = months[months.length - 1];
  }

  useEffect(() => {
    if (currentMonthIndex === -1) {
      changeMonth(startMonth + months.indexOf(selectedMonth));
    }
  }, [selectedYear, months.join(",")]);

  return (
    <div className="hid-date-picker__header">
      <Button
        variant="secondary"
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        icon={<Iconography icon="chevronLeft" size={IconographySizes.Small} />}
        aria-label="Previous month"
      />

      {/* <Select
        mode="default"
        id="selectMonth"
        name="selectMonth"
        options={months.map((month, idx) => ({
          label: month,
          value: month,
        }))}
        value={months[getMonth(date)]}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          changeMonth(months.indexOf(e.target.value))
        }
      /> */}

      <Dropdown
        id="selectMonth"
        options={months.map((month, idx) => ({
          label: month,
          value: month,
        }))}
        selected={{
          label: selectedMonth,
          value: selectedMonth,
        }}
        onChange={(opt: { label: string; value: string }) =>
          changeMonth(startMonth + months.indexOf(opt?.value))
        }
        isSearchable={false}
      />

      {/* <select
        value={months[getMonth(date)]}
        onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
      >
        {months.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select> */}
      {/* <Select
        mode="default"
        id="selectYear"
        name="selectYear"
        options={years.map((year) => ({
          label: year.toString(),
          value: year,
        }))}
        value={getYear(date)}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          changeYear(Number(e.target.value))
        }
      /> */}

      <Dropdown
        id="selectYear"
        options={years.map((year) => ({
          label: year.toString(),
          value: year,
        }))}
        selected={{ label: getYear(date).toString(), value: getYear(date) }}
        onChange={(opt: { label: string; value: string }) =>
          changeYear(Number(opt?.value))
        }
        isSearchable={false}
      />

      {/* <select
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(value)}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select> */}
      <Button
        variant="secondary"
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        icon={<Iconography icon="angleRight" size={IconographySizes.Small} />}
        aria-label="Next month"
      />
    </div>
  );
};
export default CustomHeader;
